export function mapToArray<T>(mapObject: Record<string, T>, convertFunc: ((value: [key: string, value: T]) => any)) {
    return Object.entries(mapObject).map(convertFunc);
}

export function arrayToMap<K, T>(array: K[], getId: (value: K) => string, getObject: (value: K) => T): Record<string, T> {
    const mapObject: Record<string, T> = {};
    array.forEach(_ => mapObject[getId(_)] = getObject(_));
    return mapObject;
}

export const isEmptyMap = (obj: object): boolean => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
};